module.exports = __webpack_public_path__ + "media/images/pr_detail/4-655010fc9ae9e9c86d254943ba953597.png";